import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'era-pair-code-input-ui',
  templateUrl: './pair-code-input.component.html',
  styleUrls: ['./pair-code-input.component.scss'],
  imports: [ReactiveFormsModule],
})
export class PairCodeInputComponent implements AfterViewInit {
  @ViewChild('codeInput') codeInput: ElementRef;

  public readonly codeForm: UntypedFormGroup;
  public formText: string;
  private replacedText: string;

  constructor(
    private readonly router: Router,
    private readonly formBuilder: UntypedFormBuilder
  ) {
    this.codeForm = this.createForm();
  }

  get codeControl(): AbstractControl {
    return this.codeForm.get('code');
  }

  private createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      code: [
        '',
        [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]{1,6}$')],
      ],
    });
  }

  public save() {
    if (this.codeForm.status !== 'VALID') {
      return false;
    }

    const code = this.codeControl.value;
    void this.router.navigate(['/pair', code]);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.codeInput) {
        this.codeInput.nativeElement.focus();
      }
    });
  }

  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    this.replacedText = pastedText.replace(/\r?\n|\r/g, '');
  }

  onInput() {
    if (this.replacedText) {
      this.formText = this.replacedText;
      this.replacedText = null;
    }
  }
}
